import Signal from 'libs/signals';

export const $app = Signal({});
export const $view = Signal({});
export const $form = Signal({});
export const $auth = Signal({});
export const $list = Signal({});
export const $detail = Signal({});
export const $filter = Signal({});
export const $user = Signal({});
export const $alert = Signal({
  timeOut: 3000,
  title: '',
  message: '',
});

export const handleFormChange = ({ name, value }) => {
  $form.update({
    [name]: value,
  });
};
